<template>
    <div>
        <el-dialog title="测点信息" :visible.sync="dialogChild.show" @close="closeDialog()" width="680px" center id="childCedianBox">
            <div id="cedian_panel">
                <el-form ref="ruleForm"  label-width="70px" v-for="item in childCedian" :key="item.id" style="display:inline-block" >
                    <div class="form-inline">
                        <el-form-item label="测点编号" prop="c_order" class="form-group">
                            <el-input v-model="item.c_order" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="距离位置" prop="bet_num" class="form-group">
                            <el-input v-model="item.bet_num"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <el-button @click="addChildCedain()" >+</el-button>
            </div>

            <el-dialog width="20%" style="margin-top:20px" title="确认删除子测点？" :visible.sync="deleteVisible" append-to-body>
                 <div slot="footer" class="dialog-footer">
                    <el-button @click="deleteVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleDetete()">确 定</el-button>
                </div>
            </el-dialog>

            <div slot="footer" class="dialog-footer">
                <el-button @click="deleteChild()">删除子测点</el-button>
                <el-button type="primary" @click="uploadChid('ruleForm')">确 定</el-button>
            </div>

            <!-- 子测点增加模块 -->
            <div style="display: none;" id="chidcedian_content">
                <div class="form-inline" style="margin-top: 5px;">
                    <div class="form-group">
                        <label>测点编号</label>
                        <input type="text" class="form-control" name="code" readonly="readonly">
                    </div>
                    <div class="form-group">
                        <label>距离位置</label>
                        <input type="text" class="form-control" name="bet" required>
                    </div>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import $ from 'jquery'
    import * as d3 from 'd3'

    export default {
        name: 'ChildCedian',
        props:{
            dialogChild:Object,
            childCedian:{
                Type:Array,
                default: () => []
            },
            measureNo:'',
        },
        data () {
            return {
                code:'',
                bet:'',
                betArr:[],
                codeArr:[],
                result:[],
                formData:{
                    token:'',
                    newBet:'',
                    newCode:'',
                },
                deleteVisible:false,
            }
        },
        mounted:function(){
            this.token = localStorage.getItem('token');
        },
        methods:{
            closeDialog(){
                this.dialogChild.show = false;
            },
            addChildCedain(){
                /* 拿到序号的最大值 */
                const max_order = this.childCedian.map(item => {
                    return item.c_order
                })
                let i = d3.max(max_order) + 1;

                $("#cedian_panel").append($("#chidcedian_content").html());
                $("#cedian_panel  input[name='code']").each(function() {
                    this.value = i++;
                })
            },
            uploadChid(ruleForm) {
                // 拿到bet的值
                const betInputArr = $("#cedian_panel input[name='bet']");
                for(let i = 0;i< betInputArr.length;i++){
                     this.bet = betInputArr[i].value;
                }
                this.betArr.push(this.bet);

                // 拿到code编号
                const codeInputArr = $("#cedian_panel  input[name='code']");
                for(let j = 0;j < codeInputArr.length; j++ ){
                    this.code = codeInputArr[j].value;
                }
                this.codeArr.push(this.code);

                // 拼接格式code:5_6
                const betArrString = this.betArr.toString();
                const str = betArrString.replace(/,/g, '_');
                this.formData.newBet = str;
                const codeArrString = this.codeArr.toString();
                const str2 = codeArrString.replace(/,/g, '_');
                this.formData.newCode = str2;

                // 两个数组组合成一个对象数组
                /* const zip = ([x,...xs], [y,...ys]) => {
                if (x === undefined || y === undefined)
                    return [];
                else
                    return [[x,y], ...zip(xs, ys)];
                }
                this.result = zip(this.arr, this.arr2).map(([bet, code]) => ({bet, code}));
                 */

                this.formData.token = window.localStorage.getItem('token');
                    this.$axios.post(`api/project/saveChild?measureNo=${this.measureNo}`,this.formData).then(res => {
                        this.$message({
                            type:"success",
                            message:"添加子测点信息成功",
                            showClose: true
                        });
                        this.dialogChild.show = false;
                        this.$emit('update'); //子组件使用$emit触发父组件自定义事件
                    });
                    this.formData  = {}
            },
            deleteChild(){
                this.deleteVisible = true;
            },
            handleDetete(){
                const req = {
                    token:window.localStorage.getItem('token'),
                    measureNo:this.measureNo
                }
                this.$axios.post('api/project/deleteChild',req).then(res => {
                    this.$message({
                        type:"success",
                        message:"删除子测点信息成功",
                        showClose: true
                    });
                    this.deleteVisible = false;
                    this.$emit('update');
                });
            }
        }
    }
</script>

<style>

    #chidcedian_content .el-input{
        display: inline-block;
    }

    .form-control{
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        color: #606266;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        display: inline-block;
   }

    .el-dialog__header {
      text-align: center;
      padding: 20px 30px 10px;
      /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      transition: unset;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }

    .el-dialog__title {
      text-align: center;
      font-size: 18px;
      color: #fff;
    }

    .el-form-item{
        margin-bottom: 8px;
    }

</style>

<style scoped>

    .form-inline{
        margin-top: 10px;
    }

    .form-group{
        display: inline-block
    }

    .form-group label{
        padding-right: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/components/project/ChildCedian.vue